import React from 'react';

function Footer() {
  return (
    <>
      {/* FOOTER */}
<footer>
  <canvas id="footerCanvas"></canvas>
  <div className="footer-wrap">

    {/* ── HERO BAND ── */}
    <div className="footer-hero">
      <div className="fh-left">
        <div className="fh-logo">
          <div style={{ background: '#fff', padding: '8px 12px', borderRadius: '8px', display: 'inline-block' }}>
            <img src="/logo.png" alt="Speedvault Logo" style={{ height: '32px', width: 'auto', display: 'block' }} />
          </div>
        </div>
        <h2 className="fh-headline">Payments that move at<br /><em>the speed of trust.</em></h2>
        <p className="fh-desc">Speed Vault provides innovative and secure UPI payment infrastructure, helping businesses simplify payments with advanced technology and reliable 24 × 7 support.</p>
        <div className="fh-socials">
          <a className="fh-soc" href="https://www.linkedin.com/in/speedvault-payments-private-limited-5a620433a/" target="_blank" rel="noopener">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg><span className="fh-soc-label">LinkedIn</span>
          </a>
          <a className="fh-soc" href="https://www.facebook.com/profile.php?id=61574924272165" target="_blank" rel="noopener">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg><span className="fh-soc-label">Facebook</span>
          </a>
          <a className="fh-soc" href="https://www.instagram.com/speedvaultpayments" target="_blank" rel="noopener">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg><span className="fh-soc-label">Instagram</span>
          </a>
        </div>
        <div className="fh-status">
          <span className="fh-status-dot"></span>
          <span className="fh-status-text">All systems operational</span>
        </div>
      </div>

      <div className="fh-right">
        {/* 4 stat cards */}
        <div className="fh-stats">
          <div className="fhs-card">
            <div className="fhs-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg></div>
            <div className="fhs-num">10<span className="fu">M+</span></div>
            <div className="fhs-label">Transactions / Day</div>
            <div className="fhs-bar"><div className="fhs-bar-fill" style={{width: '92%'}}></div></div>
          </div>
          <div className="fhs-card">
            <div className="fhs-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></div>
            <div className="fhs-num">99<span className="fu">.99%</span></div>
            <div className="fhs-label">Uptime SLA</div>
            <div className="fhs-bar"><div className="fhs-bar-fill" style={{width: '99%'}}></div></div>
          </div>
          <div className="fhs-card">
            <div className="fhs-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg></div>
            <div className="fhs-num">&lt;50<span className="fu">ms</span></div>
            <div className="fhs-label">Avg. Latency</div>
            <div className="fhs-bar"><div className="fhs-bar-fill" style={{width: '74%'}}></div></div>
          </div>
          <div className="fhs-card">
            <div className="fhs-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="15" rx="1"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg></div>
            <div className="fhs-num">500<span className="fu">+</span></div>
            <div className="fhs-label">Banks Connected</div>
            <div className="fhs-bar"><div className="fhs-bar-fill" style={{width: '68%'}}></div></div>
          </div>
        </div>

        {/* contact card */}
        <div className="fh-contact-card">
          <div className="fhc-item">
            <div className="fhc-icon"><svg className="sv-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></div>
            <div className="fhc-body">
              <div className="fhc-label">Email</div>
              <div className="fhc-val"><a href="mailto:business@speedvault.in">business@speedvault.in</a></div>
            </div>
          </div>
          <div className="fhc-item">
            <div className="fhc-icon"><svg className="sv-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></div>
            <div className="fhc-body">
              <div className="fhc-label">Address</div>
              <div className="fhc-val">701, Sharda Terraces, Sector 11,<br />CBD Belapur, Navi Mumbai 400614</div>
            </div>
          </div>
          <div className="fhc-item">
            <div className="fhc-icon"><svg className="sv-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></div>
            <div className="fhc-body">
              <div className="fhc-label">Support</div>
              <div className="fhc-val">24 × 7 · 365 days · 15-min P1 SLA</div>
            </div>
          </div>
          <div className="fhc-item">
            <div className="fhc-icon"><svg className="sv-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ><rect x="2" y="7" width="20" height="15" rx="1"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg></div>
            <div className="fhc-body">
              <div className="fhc-label">Registered</div>
              <div className="fhc-val">SpeedVault Payments Pvt. Ltd.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* ── NAV COLUMNS ── */}
    <div className="footer-nav">
      <div className="fnav-col">
        <div className="fnav-head">Company</div>
        <ul>
          <li><a href="https://speedvault.in">Home</a></li>
          <li><a href="https://speedvault.in/about_us">About Us</a></li>
          <li><a href="https://speedvault.in/careers">Careers</a></li>
          <li><a href="#">Press & Media</a></li>
          <li><a href="#">Blog</a></li>
        </ul>
      </div>
      <div className="fnav-col">
        <div className="fnav-head">Product</div>
        <ul>
          <li><a href="https://speedvault.in/service">Services</a></li>
          <li><a href="https://speedvault.in/solution">Solutions</a></li>
          <li><a href="#">API Documentation</a></li>
          <li><a href="#">System Status</a></li>
          <li><a href="#">Changelog</a></li>
        </ul>
      </div>
      <div className="fnav-col">
        <div className="fnav-head">Support</div>
        <ul>
          <li><a href="https://speedvault.in/contact_us">Contact Us</a></li>
          <li><a href="https://speedvault.in/ticket">Submit a Ticket</a></li>
          <li><a href="https://speedvault.in/request_a_demo">Request a Demo</a></li>
          <li><a href="https://speedvault.in/get_a_quote">Get a Quote</a></li>
          <li><a href="#">Help Centre</a></li>
        </ul>
      </div>
      <div className="fnav-col">
        <div className="fnav-head">Legal</div>
        <ul>
          <li><a href="#">Privacy Policy</a></li>
          <li><a href="#">Terms of Service</a></li>
          <li><a href="#">Security Policy</a></li>
          <li><a href="#">Cookie Policy</a></li>
          <li><a href="#">Grievance Officer</a></li>
        </ul>
      </div>
    </div>

    {/* ── NEWSLETTER ── */}
    <div className="footer-nl">
      <div className="fnl-copy">
        <div className="fnl-title">Stay ahead in digital payments.</div>
        <div className="fnl-sub">UPI insights, updates, and fintech trends — straight to your inbox.</div>
      </div>
      <div className="fnl-field">
        <input className="fnl-inp" type="email" placeholder="your@email.com" />
        <button className="fnl-sub-btn">Subscribe →</button>
      </div>
    </div>

    {/* ── COMPLIANCE BADGES ── */}
    <div className="footer-compliance">
      <span className="fc-label">Certified &amp; Compliant</span>
      <div className="fbadge"><span className="fbadge-dot"></span>NPCI Certified</div>
      <div className="fbadge"><span className="fbadge-dot"></span>RBI Compliant</div>
      <div className="fbadge"><span className="fbadge-dot"></span>PCI DSS Level 1</div>
      <div className="fbadge"><span className="fbadge-dot"></span>ISO 27001</div>
      <div className="fbadge"><span className="fbadge-dot"></span>256-bit AES</div>
      <div className="fbadge"><span className="fbadge-dot"></span>SOC 2 Type II</div>
      <div className="fbadge"><span className="fbadge-dot"></span>DPDP Act 2023</div>
      <div className="fbadge"><span className="fbadge-dot"></span>PMLA Compliant</div>
    </div>

    {/* ── BOTTOM BAR ── */}
    <div className="footer-bar">
      <span className="footer-copy">© 2024 SPEEDVAULT PAYMENTS PRIVATE LIMITED. All Rights Reserved.</span>
      <div className="footer-legal">
        <a href="#">Privacy</a>
        <a href="#">Terms</a>
        <a href="#">Security</a>
        <a href="#">Cookies</a>
      </div>
      <div className="footer-made">Built with <span className="heart">♥</span> in India</div>
    </div>

  </div>
</footer>
    </>
  );
}

export default Footer;
